import React from "react";

const SmartPagination = ({ currentPage, totalPages, onPageChange }) => {
    const generatePageNumbers = () => {
        const visiblePages = 5;
        const pages = [];

        if (totalPages <= visiblePages) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            let startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
            let endPage = startPage + visiblePages - 1;

            if (endPage > totalPages) {
                endPage = totalPages;
                startPage = endPage - visiblePages + 1;
            }

            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }
        }

        return pages;
    };

    const handleClick = (page) => {
        if (page !== currentPage && page >= 1 && page <= totalPages) {
            onPageChange(page);
        }
    };

    if (totalPages <= 1) return null;

    return (
        <div className="d-flex justify-content-center mt-3">
            <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => handleClick(1)}>
                        &laquo;
                    </button>
                </li>
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => handleClick(currentPage - 1)}>
                        &lt;
                    </button>
                </li>

                {generatePageNumbers().map((page) => (
                    <li
                        key={page}
                        className={`page-item ${currentPage === page ? "active" : ""}`}
                    >
                        <button className="page-link" onClick={() => handleClick(page)}>
                            {page}
                        </button>
                    </li>
                ))}

                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => handleClick(currentPage + 1)}>
                        &gt;
                    </button>
                </li>
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => handleClick(totalPages)}>
                        &raquo;
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default SmartPagination;
